import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

function BackHome() {
  return (
    <Link to="/" data-testid="legal-back-btn"
      className="inline-flex items-center gap-1.5 text-sm font-medium text-[#475569] hover:text-[#1E3A8A] no-underline">
      <ArrowLeft className="w-4 h-4" /> Volver
    </Link>
  );
}

export function Privacy() {
  return (
    <article className="max-w-2xl mx-auto prose-sm space-y-4" data-testid="privacy-page">
      <BackHome />
      <h1 className="font-heading text-2xl font-bold text-[#0F172A]">Política de Privacidad</h1>
      <p className="text-[#475569] leading-relaxed">Reencuentro es una herramienta privada, gratuita y humanitaria. Su único fin es ayudar a reportar y localizar personas desaparecidas o encontradas con vida tras un desastre natural.</p>
      <Section title="Qué protegemos">
        <ul className="list-disc pl-5 text-[#475569] space-y-1">
          <li>Teléfonos, correos y cédulas nunca se muestran públicamente.</li>
          <li>Las direcciones exactas y coordenadas GPS se mantienen privadas.</li>
          <li>Los datos médicos y la identidad del reportante nunca son públicos.</li>
          <li>La ubicación exacta de menores de edad siempre permanece oculta.</li>
        </ul>
      </Section>
      <Section title="Qué se publica">
        <p className="text-[#475569]">Solo una ficha pública limitada: foto segura, nombre, edad aproximada, zona amplia, ropa y señales generales, para ayudar a identificar a la persona.</p>
      </Section>
      <Section title="Contacto protegido y autónomo">
        <p className="text-[#475569]">Reencuentro facilita el intercambio protegido de información entre personas que reportan o responden a reportes. Reencuentro no verifica identidades, parentescos, custodia legal, ubicación, veracidad de la información ni acuerdos entre las partes. Cada usuario es responsable de sus decisiones, comunicaciones, acciones u omisiones.</p>
        <p className="text-[#475569]">Los datos de contacto solo se comparten cuando la persona titular de esos datos autoriza compartirlos. El equipo interviene únicamente por abuso, soporte, fallas, contenido indebido, duplicados, correcciones o eliminación, no para aprobar el contacto entre las partes.</p>
        <p className="text-[#475569]">Si no se configuran notificaciones por email, los usuarios deben consultar su reporte o solicitud dentro de Reencuentro usando su cuenta o su código privado de seguimiento.</p>
      </Section>
      <Section title="No somos">
        <p className="text-[#475569]">Reencuentro no es un sistema gubernamental, policial, médico ni forense. No es una red social ni un registro público de identidad.</p>
      </Section>
    </article>
  );
}

export function Terms() {
  return (
    <article className="max-w-2xl mx-auto space-y-4" data-testid="terms-page">
      <BackHome />
      <h1 className="font-heading text-2xl font-bold text-[#0F172A]">Términos de Uso</h1>
      <Section title="Uso de buena fe">
        <p className="text-[#475569]">Al crear un reporte confirmas que la información es verdadera y se proporciona de buena fe. El uso malicioso, la suplantación o el doxxing están prohibidos.</p>
      </Section>
      <Section title="Contenido prohibido">
        <ul className="list-disc pl-5 text-[#475569] space-y-1">
          <li>Fotos gráficas, de documentos de identidad o de personas fallecidas.</li>
          <li>Datos sensibles en campos públicos.</li>
          <li>Información falsa o engañosa.</li>
        </ul>
      </Section>
      <Section title="Moderación">
        <p className="text-[#475569]">El equipo puede revisar, ocultar o retirar casos según el nivel de riesgo, especialmente los que involucran a menores de edad.</p>
      </Section>
      <Section title="Responsabilidad de las partes">
        <p className="text-[#475569]">Reencuentro facilita un enlace protegido entre personas, pero no verifica identidades, parentescos, custodia legal ni la veracidad de la información recibida. Cada usuario es responsable de verificar la información, decidir si desea comunicarse y asumir las consecuencias de sus acciones u omisiones. Los datos de contacto solo se comparten cuando su titular lo autoriza.</p>
      </Section>
      <Section title="Finalidad humanitaria">
        <p className="text-[#475569]">Esta herramienta existe únicamente para ayudar a reunir familias. No debe usarse con fines comerciales, de investigación criminal ni de vigilancia.</p>
      </Section>
    </article>
  );
}

function Section({ title, children }) {
  return (
    <section className="space-y-2">
      <h2 className="font-heading text-lg font-semibold text-[#0F172A]">{title}</h2>
      {children}
    </section>
  );
}
